import { Flex, Loader } from '@mantine/core';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import PlaceType from 'components/shared/PlaceType';
import Text from 'components/shared/Text';
import LeadStatus from 'components/ui/lead/LeadStatus';
import { leadDrawer } from 'stores/global/RootStore';
import { createFullName, createFullNameShort } from 'utils/createFullName';
import { formatPhone } from 'utils/formatPhone';

import Item from './Item';

import s from './Details.module.scss';

const Details: React.FC = () => {
  const { lead } = leadDrawer;

  if (!lead.value) {
    return <Loader />;
  }

  return (
    <Flex gap="sm" direction="column" className={s.root}>
      <Item label="Клиент">
        <Text>{createFullName(lead.value.client)}</Text>
      </Item>
      <Item label="Телефон">
        <Text>{formatPhone(lead.value.client.phone)}</Text>
      </Item>
      <Item label="Статус">
        <LeadStatus status={lead.value.status} h="20px" />
      </Item>
      <Item label="Дата создания">{dayjs(lead.value.createdAt).format('DD.MM.YY')}</Item>
      {lead.value.fixedUntil && <Item label="Дата закрепления">{dayjs(lead.value.fixedUntil).format('DD.MM.YY')}</Item>}
      <Item label="Проект">{lead.value.project?.name ?? '—'}</Item>
      <Item label="Тип помещения">
        <PlaceType size="sm" name={lead.value.placeType?.name ?? '—'} />
      </Item>
      <Item label="Ответственный">{lead.value.user ? createFullNameShort(lead.value.user) : '—'}</Item>
      {lead.value.comment && <Item label="Комментарий">{lead.value.comment}</Item>}
    </Flex>
  );
};

export default observer(Details);
